// extracted by mini-css-extract-plugin
export default {"icon":"PathTemplatesList_icon__EkWPs"};